@use "@design/design-tokens/typography/typography" as *;
@use "@design/components/custom-scroll/custom-scroll" as *;

.root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.content {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 32px 20px 20px;
  display: flex;
  max-width: 1440px;

  &.industryTheme {
    max-width: 1280px;
    padding: 20px;
  }
}

.titleMediumLabel {
  @include typography-v2-title-md;
  color: var(--text-default);
}

.bodySmallText {
  @include typography-v2-body-sm;
  color: var(--text-default);
}

.errorMessageWrapper {
  width: 100%;
  height: calc(100vh - 40px);
  margin: 20px;
}

.skeletonWrapper {
  width: 100%;
  height: auto;
  padding: 20px;
}

.scrollWrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  @include custom-scroll-minimal;
}
